module.exports = __webpack_public_path__ + "img/bg-11.2.14279aa7.jpg";